import Vue from 'vue'
import Router from 'vue-router'
import Down from '../index'
import Chart from '../chart'
import Detail from '../detail'
import Data from '../data'
import Article from '../article'
Vue.use(Router)

let router = new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: Chart
  }, {
    path: "/chart",
    name: "chart",
    component: Chart
  }, {
    path: "/detail",
    name: "detail",
    component: Detail
  },
    {
    path: "/chart/:id",
    name: "chart",
    component: Chart
  }, {
    path: "/down",
    name: "down",
    component: Down
  }, {
    path: "/data/:id",
    name: "data",
    component: Data
  }, {
    path: "/article/:id",
    name: "article",
    component: Article
  },
  {
    path: "/data",
    name: "data",
    component: Data
  }, {
    path: "/article",
    name: "article",
    component: Article
  }]
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js